import { Checkbox } from "@material-ui/core";
import React, { memo, useContext, useState } from "react";
import { FormControlStyledLabel, RadioWrapper } from "./gol-contact-css";
import {
  GolContactFormContext,
  GolControlStyledLabel,
} from "./gol-contact-form-interfaces";

const GolCheckField = memo((props: GolControlStyledLabel) => {
  const { name, controlName, controlId, label } = props;
  const formContext = useContext(GolContactFormContext);
  const { fieldsInErrors, handleFormChange, form } = formContext;
  const [isChecked, setIsChecked] = useState(form[name] ?? false);
  const clazz = fieldsInErrors.includes(name) ? `error` : ``;

  const onCheck = (ev) => {
    setIsChecked(!isChecked);
    handleFormChange(ev);
  };

  return (
    <RadioWrapper>
      <FormControlStyledLabel
        onChange={onCheck}
        id={controlId}
        className={clazz}
        control={<Checkbox name={controlName} />}
        label={label}
        checked={isChecked ?? false}
      />
    </RadioWrapper>
  );
});

export { GolCheckField };
